(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(function () {
      const hiddenDesigns = document.querySelectorAll("._YourDesign");

      hiddenDesigns.forEach(function (div) {
        const personalizedImgUrl = div.textContent.trim();

        // Look upward for the nearest product/cart item wrapper
        const container = div.closest(".cart-items__item, .cart-item, .cart-line-item, .cart__form") || document.querySelector(".cart-page");

        if (!container) return;

        const img = container.querySelector("img");

        if (img && personalizedImgUrl) {
          img.src = personalizedImgUrl.replace(/&amp;/g, "&");
        }
      });

      observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
